import { CanvasObject } from "./object.js";

class FrameObject extends CanvasObject {
    constructor({
        context,
        saveState = null
    }) {
        super(context);
        this.name = "Frame Object";
        
        this.position = (saveState && saveState.position) ? {...saveState.position} : this.position;
        // this.dimensions = (saveState && saveState.dimensions) ? {...saveState.dimensions} : this.dimensions;

        this._init();
    }
    _init() {
        
    }
    _getObjectBoundingRect() {
        const bounds = {
            ...this.position,
            ...this.dimensions
        }
        this.boundingRect = bounds;

        return bounds;
    }
    isCursorOnObject({x, y} = {}) {
        return this._cursorInBounds({x, y});
    }
    startDragObject({controls} = {}) {
        this.dragging = true;

        this.position.before = {
            ...this.position
        }

        controls.mouse.before = {
            x: controls.mouse.x,
            y: controls.mouse.y
        }
    }
    moveTo({x, y, before}) {
        this.position = {
            x: this.position.before.x + x,
            y: this.position.before.y + y,
            before: this.position.before
        };

        this._getObjectBoundingRect();
    }
    resize({position, dimensions, cursor}) {
        const leftEdge = this.resize_boundary.type === 'edge' && this.resize_boundary.name === 'left';
        const rightEdge = this.resize_boundary.type === 'edge' && this.resize_boundary.name === 'right';
        const topEdge = this.resize_boundary.type === 'edge' && this.resize_boundary.name === 'top';
        const bottomEdge = this.resize_boundary.type === 'edge' && this.resize_boundary.name === 'bottom';

        const bottomLeftCorner = this.resize_boundary.type === 'bottom.corner' && this.resize_boundary.name === 'left';
        const bottomRightCorner = this.resize_boundary.type === 'bottom.corner' && this.resize_boundary.name === 'right';
        const topLeftCorner = this.resize_boundary.type === 'top.corner' && this.resize_boundary.name === 'left';
        const topRightCorner = this.resize_boundary.type === 'top.corner' && this.resize_boundary.name === 'right';

        // resizing logic for frame object
        if( rightEdge ) this.dimensions.width = this.dimensions.before.width + cursor.x;
        else if( leftEdge ) {
            this.position.x = this.position.before.x + cursor.x;
            this.dimensions.width = this.dimensions.before.width - cursor.x;
        }
        else if( topEdge ) {
            this.position.y = this.position.before.y + cursor.y;
            this.dimensions.height = this.dimensions.before.height - cursor.y;
        }
        else if( bottomEdge ) this.dimensions.height = this.dimensions.before.height + cursor.y;
        else if( topRightCorner ) {
            this.position.y = this.position.before.y + cursor.y;
            this.dimensions.width = this.dimensions.before.width + cursor.x;
            this.dimensions.height = this.dimensions.before.height - cursor.y;
        }
        else if( topLeftCorner ) {
            this.position.x = this.position.before.x + cursor.x;
            this.position.y = this.position.before.y + cursor.y;
            this.dimensions.width = this.dimensions.before.width - cursor.x;
            this.dimensions.height = this.dimensions.before.height - cursor.y;
        }
        else if( bottomRightCorner ) {
            this.dimensions.width = this.dimensions.before.width + cursor.x;
            this.dimensions.height = this.dimensions.before.height + cursor.y;
        }
        else if( bottomLeftCorner ) {
            this.position.x = this.position.before.x + cursor.x;
            this.dimensions.width = this.dimensions.before.width - cursor.x;
            this.dimensions.height = this.dimensions.before.height + cursor.y;
        }

        this._getObjectBoundingRect();
    }
    startResizeObject({controls, resize_boundary} = {}) {
        this.resizing = true;
        this.resize_boundary = resize_boundary;

        this.dimensions.before = {
            width: this.dimensions.width,
            height: this.dimensions.height
        }

        this.position.before = {
            x: this.position.x,
            y: this.position.y
        }

        controls.mouse.before = {
            x: controls.mouse.x,
            y: controls.mouse.y
        }
    }
    setDimensions({w, h}) {
        this.dimensions.width = w;
        this.dimensions.height = h;

        this._getObjectBoundingRect();

        // creator:object:update
        this.context.canvas.dispatchEvent(new CustomEvent('creator:object:update', {
            detail: {
                context: this.context,
                object: this
            }
        }));
    }
    setPosition({x, y}) {
        this.position.x = x;
        this.position.y = y;

        this._getObjectBoundingRect();

        // creator:object:update
        this.context.canvas.dispatchEvent(new CustomEvent('creator:object:update', {
            detail: {
                context: this.context,
                object: this
            }
        }));
    }
    render() {
        this.context.fillStyle = 'white';

        this.context.beginPath();
        this.context.rect(
            this.position.x,
            this.position.y,
            this.dimensions.width, 
            this.dimensions.height
        );
        this.context.fill();
        if(this.selected && !this.editing) this.showSelected();
        if(this.hovered) this.showHover();
    }
    getState() {
        return {
            type: "FrameObject",
            position: { ...this.position },
            dimensions: { ...this.dimensions }
        }
    }
}

export {
    FrameObject
}